/**
 * WorkflowExpandTrigger.tsx — 可点击 ⎿ 摘要行（D24 P2）
 *
 * 职责：Done teaser / Parallel 组摘要的展开入口；hint 与摘要同属 button。
 *
 * 链路位置：WorkflowStageContainer · WorkflowParallelGroup。
 */
import type { ReactNode } from 'react';

export interface WorkflowExpandTriggerProps {
  summary: ReactNode;
  summaryTestId?: string;
  teaser?: ReactNode;
  expandHint?: string | null;
  onToggle: () => void;
  expanded?: boolean;
  testId?: string;
  teaserTestId?: string;
  className?: string;
}

export function WorkflowExpandTrigger({
  summary,
  summaryTestId,
  teaser,
  expandHint,
  onToggle,
  expanded = false,
  testId,
  teaserTestId,
  className = '',
}: WorkflowExpandTriggerProps) {
  return (
    <button
      type="button"
      className={`lax-workflow-expand-trigger${className ? ` ${className}` : ''}`}
      onClick={onToggle}
      aria-expanded={expanded}
      data-testid={testId}
    >
      <span className="lax-workflow-expand-trigger__summary" data-testid={summaryTestId}>
        ⎿ {summary}
      </span>
      {teaser ? (
        <span
          className="lax-workflow-expand-trigger__teaser"
          data-testid={teaserTestId}
        >
          {teaser}
        </span>
      ) : null}
      {expandHint ? (
        <span className="lax-workflow-expand-trigger__hint">{expandHint}</span>
      ) : null}
    </button>
  );
}
